interface SignOutResult {
  error: unknown | null;
}

/**
 * Fail closed before an asynchronous sign-out can yield, then repeat the
 * isolation in `finally` so delayed and rejected requests cannot restore
 * owner-bound navigation state.
 */
export async function signOutWithNavigationIsolation(
  signOutRequest: () => Promise<SignOutResult>,
  clearLocalIdentity: () => void,
  clearNavigationOwner: () => void,
): Promise<void> {
  clearLocalIdentity();
  clearNavigationOwner();

  try {
    const { error } = await signOutRequest();
    if (error) throw error;
  } finally {
    clearLocalIdentity();
    clearNavigationOwner();
  }
}
